import type { AccessStatus } from "../types";

/** App icons may only load from https origins we trust (defence against
 *  arbitrary-origin image loads). Keep in sync with ALLOWED_ICON_ORIGINS
 *  in the backend config. */
const ALLOWED_ICON_ORIGINS = new Set<string>([
  "https://signal.bounteous.tools",
  "https://tokentrail.qiplabs.ai",
  "https://echo.bounteous.app",
  "https://katha.bounteous.app",
]);

export function safeIconUrl(url: string | null): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.protocol !== "https:") return null;
    if (!ALLOWED_ICON_ORIGINS.has(u.origin)) return null;
    return u.href;
  } catch {
    return null;
  }
}

export function accessLabel(status: AccessStatus): string {
  if (status === "granted") return "Access granted";
  if (status === "pending") return "Request pending";
  return "No access";
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  const out = parts.map((p) => p[0]?.toUpperCase() ?? "").join("");
  return out || "?";
}
